import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class ChairmanInvite extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        console.log("pathname", this.props.location)
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                <div className="website">
                    <section className="banner page-banner position-relative pb-0">
                        <div className="overlay"></div>
                        <div className="container">
                            <div className="page-title text-center position-relative py-9">
                                <h2 className="text-white text-uppercase mt-4">Chairman Invite</h2>
                            </div>
                        </div>
                    </section>
                    <section className="conference">
                        <div className="container">
                            <div className="conference-inner text-center">
                                <div className="row gx-lg-5 align-items-center">
                                    <div className="col-lg-5 order-2 order-lg-1">
                                        <div className="conference-left ">
                                            <div className="row align-items-center">
                                                <div className="col-lg-8 col-md-6 px-2">
                                                    <div className="benifit-list-box py-1 px-1 rounded box-shadow bg-white">
                                                        {/* <div class="list-box-icon">
                                      <i class="fa fa-bar-chart pink mb-3"></i>
                                  </div>
                                  <div class="list-box-body">
                                      <h5 class="mb-2">Digital Marketing</h5>
                                      <p class="mb-2 w-75 m-auto">Duis aute irure dolor in reprehenderit</p>
                                      <div class="box-btn">
                                          <a class="pink p-0" href="event-detail.html">Learn More<i
                                                  class="fa fa-long-arrow-right ms-2"></i></a>
                                      </div>
                                  </div> */}
                                                        <img
                                                            src="static/images/chairman.jpg"
                                                            alt="group-image"
                                                            className="w-100 rounded"
                                                        />
                                                        <h4 className="mt-3">Ketan Sanghvi</h4>
                                                        <p>Chairman, India ITME Society</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 order-1 order-lg-2">
                                        <div className="event-benifit-list-right text-lg-start">
                                            <div className="overview-title pb-6">
                                                {/* <h2 class="mb-2">Chairman <span class="pink"> Message</span></h2> */}
                                            </div>
                                            <div className="overview-info">
                                                <p>Greetings from India ITME Society!</p>
                                                <p className="mb-2">I am glad to present the 3rd edition of India ITME Awards - an honest attempt to encourage high performance in the textile engineering and technology industry. Taking forward the success & learnings of previous editions, we embark on a journey for appreciating and rewarding the excellence & innovations in textile engineering and technology by launching the India ITME Awards biennially henceforth.</p>
                                                <p className="mb-2">Hoping this edition will bring enthusiastic and energetic applications in multitudes across all the categories. I am eager to receive worthy applications in abundance and be a platform that will inspire technology-driven India. I wish the best of success to all the applicants across categories.</p>
                                                <p className="mb-2">Let excellence in technology and ground-breaking innovations lead the winning streak that inspires us to go beyond and make a mark for India in the technology power domain.</p>
                                                <p className="mb-2">I look forward to welcoming you to the India ITME Awards.</p>

                                                <p className="mb-0">Ketan Sanghvi,</p>
                                                <p className="mb-0">Chairman</p>
                                                <p className="mb-0">India ITME Society</p>
                                                
                                                {/* <div class="overview-btn">
                              <a class="btn my-4" href="javascript:void(0);">Join Event <i
                                      class="fa fa-angle-double-right"></i></a>
                          </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(ChairmanInvite)
);
